import { gql, useQuery } from '@apollo/client';

import { UserContext } from '../../../graphql/athena/queries/__generated__/UserContext';

export const ATHENA_SESSION = gql`
  query UserContext {
    web {
      userSession {
        human {
          full_name
          customer_uuid
        }
      }
    }
  }
`;

export const useAthenaSessionQuery = () => {
  const { data, loading, error } = useQuery<UserContext>(ATHENA_SESSION, {
    context: {
      clientName: 'athena',
    },
  });
  const customerUuid = data?.web.userSession?.human?.customer_uuid;
  return { customerUuid, data, loading, error };
};
